

export const frontMatter = {};
export const contentTitle = undefined;
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-tutorials-correcting-baseline-with-top-hat-md-c78.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Histogram before applying topHat",
  "id": "histogram-before-applying-tophat",
  "level": 3
}, {
  "value": "Histogram after applying topHat",
  "id": "histogram-after-applying-tophat",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h3: "h3",
    img: "img",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "There are moments when an image doesn't have a perfect lightning and you have uneven background like here."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "sudoku",
        src: require("!/opt/buildhome/repo/node_modules/url-loader/dist/cjs.js?limit=10000&name=assets/images/[name]-[contenthash].[ext]&fallback=/opt/buildhome/repo/node_modules/file-loader/dist/cjs.js!./images/topHat correction/sudoku.png").default + "",
        width: "255",
        height: "256"
      })
    }), "\n", _jsx(_components.p, {
      children: "So, when extracting regions of interest the regular way you will have a mask like that:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "//The default algorithm used is\n//\"otsu\".\nmask = image.threshold();\n"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "Global threshold",
        src: require("!/opt/buildhome/repo/node_modules/url-loader/dist/cjs.js?limit=10000&name=assets/images/[name]-[contenthash].[ext]&fallback=/opt/buildhome/repo/node_modules/file-loader/dist/cjs.js!./images/topHat correction/globalThreshMask.jpg").default + "",
        width: "255",
        height: "256"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The cause of this is the nature of the threshold algorithm. In ImageJS it takes a global threshold variable, which means that the algorithms calculate one value and compare it with all the pixels to create a Mask. Obviously, such approach is not very effective when there are smooth shades and uneven illumination.\nOne of the ways to deal with uneven illumination and improve the output is to apply ", _jsx(_components.code, {
        children: "topHat"
      }), "() method. It is a method that subtracts the result of morphological opening from the original image."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "image = image.grey().invert();\n//Big structuring element is necessary for\nconst kernel = Array(101).fill(Array(101).fill(1));\nimage = image.topHat({ kernel });\n"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "topHat comparison",
        src: require("!/opt/buildhome/repo/node_modules/url-loader/dist/cjs.js?limit=10000&name=assets/images/[name]-[contenthash].[ext]&fallback=/opt/buildhome/repo/node_modules/file-loader/dist/cjs.js!./images/topHat correction/topHatComp.png").default + "",
        width: "510",
        height: "258"
      })
    }), "\n", _jsx(_components.p, {
      children: "Therefore if we look at the histograms of these two images at a given point we will see that the intensities are spread more evenly after topHat, rather than before."
    }), "\n", _jsx(_components.h3, {
      id: "histogram-before-applying-tophat",
      children: "Histogram before applying topHat"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: require("!/opt/buildhome/repo/node_modules/url-loader/dist/cjs.js?limit=10000&name=assets/images/[name]-[contenthash].[ext]&fallback=/opt/buildhome/repo/node_modules/file-loader/dist/cjs.js!./images/topHat correction/histBeforeTopHat.svg").default + ""
      })
    }), "\n", _jsx(_components.h3, {
      id: "histogram-after-applying-tophat",
      children: "Histogram after applying topHat"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: require("!/opt/buildhome/repo/node_modules/url-loader/dist/cjs.js?limit=10000&name=assets/images/[name]-[contenthash].[ext]&fallback=/opt/buildhome/repo/node_modules/file-loader/dist/cjs.js!./images/topHat correction/histAfterTopHat.svg").default + ""
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

